import { useState } from "react";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//APP
import { removerAcentos } from "../../../../utils";
import { useGetAtividadesGerais, useGetPropriedadesDoCliente } from "../../../../services/atividades/GET";

//COMPONENTS
import Input from "../../../../Components/CustomUi/input";
import Carregando from "../../../../Components/CustomUi/loading";
import ButtonCustom from "../../../../Components/ButtonCustom";
import { RowItem } from "../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../Components/CustomUi/table/rowTable";
import { AtvsTodas } from "./components/atvsTodas";
import { BodyTable } from "../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../Components/CustomUi/table/headerTable";
import { DrawerCustom } from "../../../../Components/CustomUi/Drawer";
import { CompraInsumos } from "./components/compraInsumos";
import { AtvsExecutadas } from "./components/atvsExecutadas";
import { DefautContainer } from "../../../../Components/CustomUi/defaultContainer";
import { PlanejamentoInsumos } from "./components/planejamentoInsumos";
import { ComparativoInsumos } from "./components/comparativoInsumos";

const tipos_relatorios: { nome: string; descricao: string; action: string }[] = [
    {
        nome: 'Atividades Planejadas',
        descricao: 'Relatório de atividades planejadas',
        action: 'atividades_planejadas',
    },
    {
        nome: 'Execuções de atividades',
        descricao: 'Relatório de execuções de atividades',
        action: 'execucoes_atividades',
    },
    {
        nome: 'Planejamento de insumos detalhado',
        descricao: 'Relatório detalhado de planejamento de insumos',
        action: 'planejamento_insumos',
    },
    {
        nome: 'Insumos totalizados',
        descricao: 'Relatório de insumos totalizados',
        action: 'insumos_totalizados',
    },
    {
        nome: 'Comparativo planejamento e execução de insumos',
        descricao: 'Relatório comparativo entre os insumos planejados e executados',
        action: 'comparativo_insumos',
    },
];

export const RelatoriosAtv: React.FC = () => {

    //#region STATES
    const [buscar_relatorio, setBuscar_relatorio] = useState<string>('');
    const [open_gaveta, setOpen_gaveta] = useState<boolean>(false);
    const [tipo_relatorio_selecionado, setTipo_relatorio_selecionado] = useState<string>('');
    //#endregion

    //#region API
    const { data_propriedades, carregando_propriedades } = useGetPropriedadesDoCliente(); //lista as propriedades com os talhões
    const { data_atividades, carregando_atividades } = useGetAtividadesGerais(); //lista todas as atividades de todas as propriedades do cliente
    //#endregion

    return (
        <DefautContainer
            title="Relatórios"
            id_safra="/atividades/relatorios"
        >
            <Input
                placeholder="Buscar relatório"
                value={buscar_relatorio}
                onChange={setBuscar_relatorio}
            />

            {carregando_propriedades || carregando_atividades ? (
                <Carregando
                    animation
                    legenda="Carregando dados das atividades..."
                    justifyContent="center"
                    height={500}
                />
            ) : (
                <>
                    <HeaderTable
                        itens={[
                            { valor: 'Relatório', width: 350 },
                            { valor: 'Descrição', width: 'calc(100% - 460px)' },
                            { valor: 'Opções', width: 110 },
                        ]}
                    />
                    <BodyTable style={{ marginTop: -10 }}>
                        {tipos_relatorios
                            .filter(({ nome, descricao }) => {
                                const busca = removerAcentos(buscar_relatorio.toLowerCase());
                                return removerAcentos(nome.toLowerCase()).includes(busca) ||
                                    removerAcentos(descricao.toLowerCase()).includes(busca);
                            })
                            .map(({ nome, descricao, action }, index) => (
                                <RowTable key={index} onDoubleClick={() => { setTipo_relatorio_selecionado(action); setOpen_gaveta(true) }}>
                                    <RowItem width={350}>
                                        {nome}
                                    </RowItem>
                                    <RowItem width={'calc(100% - 460px)'}>
                                        {descricao}
                                    </RowItem>
                                    <RowItem width={110}>
                                        <ButtonCustom
                                            icon={<FontAwesomeIcon icon={faPrint} />}
                                            onClick={() => { setTipo_relatorio_selecionado(action); setOpen_gaveta(true) }}
                                        >
                                            Gerar
                                        </ButtonCustom>
                                    </RowItem>
                                </RowTable>
                            ))}
                    </BodyTable>
                </>
            )}


            <DrawerCustom
                open={open_gaveta}
                onClose={() => setOpen_gaveta(false)}
                title={tipos_relatorios.find(i => i.action === tipo_relatorio_selecionado)?.nome}
                width={500}
            >
                {tipo_relatorio_selecionado === 'atividades_planejadas' && (
                    <AtvsTodas
                        data_propriedades={data_propriedades}
                        data_atividades={data_atividades}
                    />
                )}
                {tipo_relatorio_selecionado === 'execucoes_atividades' && (
                    <AtvsExecutadas
                        data_propriedades={data_propriedades}
                        data_atividades={data_atividades}
                    />
                )}

                {tipo_relatorio_selecionado === 'planejamento_insumos' && (
                    <PlanejamentoInsumos
                        data_propriedades={data_propriedades}
                        data_atividades={data_atividades}
                    />
                )}

                {tipo_relatorio_selecionado === 'insumos_totalizados' && (
                    <CompraInsumos
                        data_propriedades={data_propriedades}
                        data_atividades={data_atividades}
                    />
                )}

                {tipo_relatorio_selecionado === 'comparativo_insumos' && (
                    <ComparativoInsumos
                        data_propriedades={data_propriedades}
                        data_atividades={data_atividades}
                    />
                )}

            </DrawerCustom>
        </DefautContainer>
    );
};